<template>
  <div style="height: calc(100% - 92px);">
    <el-cascader style="width: 100%;" v-model="classSelect" :placeholder="classPlaceholder" :props="classProps"
      :options="classes" @change="onFilterClass"></el-cascader>
    <el-input v-model="searchQuery" placeholder="请输入学生姓名" @input="onSearchStudent" style="margin: 6px 0;" />
    <div v-if="friends.length">
      <el-menu :default-active="activeFriend" @select="handleSelect">
        <el-menu-item v-for="(friend, index) in friends" :key="index" :index="'' + friend.patriarchId">
          {{ friend.name ? friend.name : friend.studentName + '家长' }}
        </el-menu-item>
      </el-menu>
    </div>
    <el-empty v-else style="height: 100%;" :image-size="100" description="暂无数据"></el-empty>
  </div>
</template>

<script>
export default {
  props: {
    classes: Array,
    friends: Array,
    activeFriend: [String, Number],
    classPlaceholder: String,
    className: [Object, Array]
  },
  data() {
    return {
      classSelect: [],
      // 级联选择器属性配置
      classProps: {
        expandTrigger: "hover",
        children: "schoolClassList",
      },
      searchQuery: ''
    }
  },
  mounted() {
    this.classSelect = this.className;
  },
  methods: {
    handleSelect(friendId) {
      // console.log(`Selected friend: ${friendId}`);
      this.$emit('select-friend', friendId);
    },
    onFilterClass(classId) {
      this.$emit('filter-class', classId);
    },
    onSearchStudent(query) {
      this.$emit('search-student', query);
    }
  }
};
</script>

<style scoped>
/* Add your styles here */
</style>